module.exports = __webpack_public_path__ + "static/media/flipVertical.660456fb.svg";